
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { EmailSettings } from "@/components/admin/email/EmailSettings";

export default function AdminSettings() {
  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-bold">Admin Instellingen</h1>
      
      <Tabs defaultValue="email" className="w-full">
        <TabsList className="mb-4">
          <TabsTrigger value="general">Algemeen</TabsTrigger>
          <TabsTrigger value="email">Email</TabsTrigger>
          <TabsTrigger value="users">Gebruikers</TabsTrigger>
          <TabsTrigger value="security">Veiligheid</TabsTrigger>
        </TabsList>

        <TabsContent value="general">
          <Card>
            <CardHeader>
              <CardTitle>Algemene Instellingen</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground">
                Algemene instellingen komen hier...
              </p>
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="email">
          <EmailSettings />
        </TabsContent>

        <TabsContent value="users">
          <Card>
            <CardHeader>
              <CardTitle>Gebruikers Instellingen</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground">
                Gebruikers instellingen komen hier...
              </p>
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="security">
          <Card>
            <CardHeader>
              <CardTitle>Veiligheids Instellingen</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground">
                Veiligheids instellingen komen hier...
              </p>
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  );
}
